/**
 * Check if window is defined - safe for SSR
 * Always call this as a function: isWindowDefined()
 */
export const isWindowDefined = () => typeof window !== "undefined";
